import { render, staticRenderFns } from "./CardFormService.vue?vue&type=template&id=b4e8aeec&scoped=true"
import script from "./CardFormService.vue?vue&type=script&lang=js"
export * from "./CardFormService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e8aeec",
  null
  
)

export default component.exports